import { QueryClient } from '@tanstack/react-query'

// Единый QueryClient: делится между QueryProvider (рендер) и router-context
// (loader'ы/beforeLoad делают ensureQueryData вне дерева React).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: { retry: 0 },
  },
})
